import 'lazysizes'
import 'tiny-editor'
import ArchiveProducts from './archive-products'
import BlockGallery from "./block/gallery"
import Cart from './cart'
import CartButton from './cart-button'
import Checkout from './checkout'
import CookieConsent from './cookie-consent'
import CCVBalanceChecker from './ccv/balance-checker'
import Header from './header'
import InputNumber from './components/input-number'
import BlogCards from "./blog/cards"
import SingleProduct from "./single-product";
import VideoOverlay from "./components/video-overlay";
import Video from "./components/video";
import Webshop from './webshop'
import MyCompany from "./my-account/my-company";
import WoocommerceNotices from "./woocommerce-notices";
import Filters from "./components/filters";
import ArchivesCards from "./archives/cards";
import ArchivesHeaderWithMap from "./archives/map";
import Home from "./home";
import ArchivesSingleMap from "./archives/archives-single-map";
if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = Array.prototype.forEach;
}
// Document loaded
document.addEventListener('DOMContentLoaded', function () {
    initComponent('.block-embed', element => new VideoOverlay(element))
    initComponent('.video', element => new Video(element))
    initComponent('.block-gallery', element => new BlockGallery(element))
    initComponent('.blog-cards', element => new BlogCards(element))
    initComponent('.archives-list-cards', element => new BlogCards(element))
    initComponent('.archive-list-header-with-map', element => new ArchivesHeaderWithMap(element))
    initComponent('.archives-single-info-google-map', element => new ArchivesSingleMap(element))
    initComponent('.cart', element => new Cart(element))
    initComponent('.cart-button', element => new CartButton(element))
    initComponent('.ccv-balance', element => new CCVBalanceChecker(element))
    initComponent('.checkout', element => new Checkout(element))
    initComponent('.cookie-consent', element => new CookieConsent(element))
    initComponent('.header', element => new Header(element))
    initComponent('.input-numbers', element => new InputNumber(element))
    initComponent('.product', element => new SingleProduct(element))
    initComponent('.products', element => new ArchiveProducts(element))
    //initComponent('.products', element => new Webshop(element))
    initComponent('.my-company', element => new MyCompany(element))
    initComponent('.woocommerce-notices-wrapper', element => new WoocommerceNotices(element))
    initComponent('.filters', element => new Filters(element))
    initComponent('.home', element => new Home(element))
});

// Global helper to find and initialize components
function initComponent(selector, callback) {
    const elements = document.querySelectorAll(selector)
    elements.forEach(function (element) {
        callback(element)
    });
}

window.initComponent = initComponent;
